/* --- Slick Slider Initialization --- */
jQuery(document).ready(function ($) {
  if ($(".hero-slider__wrapper").length) {
    $(".hero-slider__wrapper").slick({
      arrows: true,
      autoplay: true,
      prevArrow: `<button type="button" class="slick-prev"><svg width="8" height="13" viewBox="0 0 8 13" fill="none"><path d="M7.99203 2.34042L6.58203 0.93042L0.582031 6.93042L6.58203 12.9304L7.99203 11.5204L3.41203 6.93042L7.99203 2.34042Z" fill="#1B1C4A"/></svg></button>`,
      nextArrow: `<button type="button" class="slick-next"><svg width="8" height="13" viewBox="0 0 8 13" fill="none"><path d="M1.58187 0.0408936L0.171875 1.45089L4.75187 6.04089L0.171875 10.6309L1.58187 12.0409L7.58187 6.04089L1.58187 0.0408936Z" fill="black"/></svg></button>`,
    });
  }

  if ($(".slick-partners").length) {
    $(".slick-partners").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      dots: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } },
      ],
    });
  }
});

/* --- Main Site Functionality --- */
document.addEventListener("DOMContentLoaded", function () {
  // --- 1. Numbers Counter Logic ---
  const counters = document.querySelectorAll(".js-counter");
  if (counters.length > 0) {
    counters.forEach((counter) => {
      const target = +counter.getAttribute("data-target");
      const duration = 2000;
      const startTime = performance.now();
      function updateCounter(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const currentValue = Math.floor(progress * target);
        counter.textContent = currentValue + (target > 10 ? "+" : "");
        if (progress < 1) requestAnimationFrame(updateCounter);
      }
      requestAnimationFrame(updateCounter);
    });
  }

  // --- 2. Right Side Drawer (Hamburger Menu) ---
  const closeBtn = document.getElementById("closeDrawer");
  const drawer = document.getElementById("sideDrawer");
  const overlay = document.getElementById("drawerOverlay");

  // if (openBtn && drawer && overlay) {
  //   openBtn.addEventListener("click", (e) => {
  //     e.preventDefault();
  //     drawer.classList.add("active");
  //     overlay.classList.add("active");
  //     document.body.style.overflow = "hidden";
  //   });

  //   const closeDrawer = () => {
  //     drawer.classList.remove("active");
  //     overlay.classList.remove("active");
  //     document.body.style.overflow = "auto";
  //   };

  //   if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
  //   overlay.addEventListener("click", closeDrawer);
  // }

  const toggleBtn = document.getElementById("openDrawer");

  if (toggleBtn && drawer && overlay) {
    function toggleDrawer() {
      const isActive = drawer.classList.contains("active");

      if (isActive) {
        // Close Logic
        drawer.classList.remove("active");
        overlay.classList.remove("active");
        toggleBtn.classList.remove("active");
        document.body.style.overflow = "auto";
      } else {
        // Open Logic
        drawer.classList.add("active");
        overlay.classList.add("active");
        toggleBtn.classList.add("active");
        document.body.style.overflow = "hidden";
      }
    }

    toggleBtn.addEventListener("click", (e) => {
      e.preventDefault();
      toggleDrawer();
    });

    overlay.addEventListener("click", toggleDrawer);
    closeBtn.addEventListener("click", toggleDrawer)
  }

  // --- 3. Product Gallery Logic ---
  const mainProductImage = document.querySelector("#mainProductImage");
  const mainArrowLeft = document.querySelector("#mainProductArrowLeft");
  const mainArrowRight = document.querySelector("#mainProductArrowRight");
  const thumbnails = document.querySelectorAll(".product-images-box");

  // Only run if the main gallery elements exist
  if (mainProductImage && thumbnails.length > 0) {
    const images = Array.from(thumbnails).map(
      (box) => box.querySelector("img").src
    );
    let currentIndex = 0;

    function setImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentIndex = index;
      mainProductImage.src = images[currentIndex];
      thumbnails.forEach((t) => t.classList.remove("active"));
      thumbnails[currentIndex].classList.add("active");
    }

    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener("click", () => setImage(index));
    });

    if (mainArrowLeft)
      mainArrowLeft.addEventListener("click", () => setImage(currentIndex - 1));
    if (mainArrowRight)
      mainArrowRight.addEventListener("click", () =>
        setImage(currentIndex + 1)
      );
  }

  // --- 4. Accessible Tabs Logic ---
  function initTabs(container) {
    const tablist = container.querySelector("[role='tablist']");
    if (!tablist) return; // Guard clause

    const tabs = Array.from(tablist.querySelectorAll("[role='tab']"));
    if (tabs.length === 0) return;

    const firstTab = tabs[0];
    const lastTab = tabs[tabs.length - 1];

    function activateTab(tab) {
      const tabpanelID = tab.getAttribute("aria-controls");
      const tabpanel = document.getElementById(tabpanelID);
      tab.setAttribute("aria-selected", true);
      tab.removeAttribute("tabindex");
      if (tabpanel) tabpanel.setAttribute("tabindex", 0);

      document
        .querySelectorAll('[role="tab"], [role="tabpanel"]')
        .forEach((el) => {
          if (el !== tab && el !== tabpanel) {
            if (el.matches('[role="tab"]')) {
              el.setAttribute("aria-selected", false);
              el.setAttribute("tabindex", -1);
            } else {
              el.removeAttribute("tabindex");
            }
          }
        });
    }

    tablist.addEventListener("click", (e) => {
      if (e.target.matches('[role="tab"]')) activateTab(e.target);
    });

    tablist.addEventListener("keydown", (e) => {
      if (!e.target.matches('[role="tab"]')) return;
      let index = tabs.indexOf(e.target);
      switch (e.key) {
        case "ArrowLeft":
          activateTab(index === 0 ? lastTab : tabs[index - 1]);
          break;
        case "ArrowRight":
          activateTab(index === tabs.length - 1 ? firstTab : tabs[index + 1]);
          break;
        case "Home":
          activateTab(firstTab);
          firstTab.focus();
          break;
        case "End":
          activateTab(lastTab);
          lastTab.focus();
          break;
      }
    });
  }

  const tabContainers = document.querySelectorAll(".tabs");
  if (tabContainers.length > 0) tabContainers.forEach(initTabs);
});


